import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { AdvertisementPage } from "src/app/advertisement/advertisement.page";
import { ServicesProvider } from "./services";
import { TranslateService } from "@ngx-translate/core";
import { formatDate } from "@angular/common";


@Injectable()
export class AddCall {

    addImg: any; vaccinPatientId: any; vaccinIndex: any;
    Date: any; infantPatientProfileImg: any;
    dynClass: any;
    moduleName: any;
    adddetails: any = [];


    changeDate: any;
    selectedLanguage: any;

    public title!: string;
    public title_2!: string;
    public description!: string;
    public name!: string;
    public language: string;


    public title1: string;
    public title2: string;
    public title3: string;
    public title4: string;
    public title5: string;
    public title6: string;
    public title7: string;
    public title8: string;
    public title9: string;
    public title10: string;
    public title11: string;
    public title12: string;
    public title13: string;
    public title14: string;
    public title15: string;
    public title16: string;
    public title17: string;
    public title18: string;
    public title19: string;
    public title20: string;
    public title21: string;
    public title22: string;
    public title23: string;
    public title24: string;
    public title25: string;
    public title26: string;
    public title27: string;
    public title28: string;
    public title29: string;
    public title30: string;
    public title31: string;
    public title32: string;
    public title33: string;
    public title34: string;
    public title35: string;
    public title36: string;
    public title37: string;
    public title38: string;
    public title39: string;
    public title40: string;
    public title41: string;
    public title42: string;
    public title43: string;
    public title44: string;
    public title45: string;
    public title46: string;
    public title47: string;
    public title48: string;
    public title49: string;
    public title50: string;
    public title51: string;
    public title52: string;
    public title53: string;
    public title54: string;
    public title55: string;
    public title56: string;
    public title57: string;
    public title58: string;
    public title59: string;
    public title60: string;
    public title61: string;
    public title62: string;
    public title63: string;
    public title64: string;
    public title65: string;
    public title66: string;
    public title67: string;
    public title68: string;
    public title69: string;
    public title70: string;
    public title71: string;
    public title72: string;
    public title73: string;
    public title74: string;
    public title75: string;
    public title76: string;
    public title77: string;
    public title78: string;
    public title79: string;
    public title80: string;
    public title81: string;
    public title82: string;
    public title83: string;
    public title84: string;
    public title85: string;
    public title86: string;
    public title87: string;
    public title88: string;
    public title89: string;
    public title90: string;
    public title91: string;
    public title92: string;
    public title93: string;
    public title94: string;
    public title95: string;
    public title96: string;
    public title97: string;
    public title98: string;
    public title99: string;
    public title100: string;
    public title101: string;
    public title102: string;
    public title103: string;
    public title104: string;
    public title105: string;
    public title106: string;
    public title107: string;
    public title108: string;
    public title109: string;
    public title110: string;
    public title111: string;
    public title112: string;
    public title113: string;
    public title114: string;
    public title115: string;
    public title116: string;
    public title117: string;
    public title118: string;
    public title119: string;
    public title120: string;
    public title121: string;
    public title122: string;
    public title123: string;
    public title124: string;
    public title125: string;
    public title126: string;
    public title127: string;
    public title128: string;
    public title129: string;
    public title130: string;
    public title131: string;
    public title132: string;
    public title133: string;
    public title134: string;
    public title135: string;
    public title136: string;
    public title137: string;
    public title138: string;
    public title139: string;
    public title140: string;
    public title141: string;
    public title142: string;
    public title143: string;
    public title144: string;
    public title145: string;
    public title146: string;
    public title147: string;
    public title148: string;
    public title149: string;
    public title150: string;
    public title151: string;
    public title152: string;
    public title153: string;
    public title154: string;
    public title155: string;
    public title156: string;
    public title157: string;
    public title158: string;
    public title159: string;
    public title160: string;
    public title161: string;
    public title162: string;
    public title163: string;
    public title164: string;
    public title165: string;
    public title166: string;
    public title167: string;
    public title168: string;
    public title169: string;
    public title170: string;
    public title171: string;
    public title172: string;
    public title173: string;
    public title174: string;
    public title175: string;
    public title176: string;
    public title177: string;
    public title178: string;
    public title179: string;
    public title180: string;
    public title181: string;
    public title182: string;
    public title183: string;
    public title184: string;
    public title185: string;
    public title186: string;
    public title187: string;
    public title188: string;
    public title189: string;
    public title190: string;
    public title191: string;
    public title192: string;
    public title193: string;
    public title194: string;
    public title195: string;
    public title196: string;
    public title197: string;
    public title198: string;
    public title199: string;
    public title200: string;
    public title201: string;
    public title202: string;
    public title203: string;
    public title204: string;
    public title205: string;
    public title206: string;
    public title207: string;
    public title208: string;
    public title209: string;
    public title210: string;
    public title211: string;
    public title212: string;
    public title213: string;
    public title214: string;
    public title215: string;
    public title216: string;
    public title217: string;
    public title218: string;
    public title219: string;
    public title220: string;
    public title221: string;
    public title222: string;
    public title223: string;
    public title224: string;
    public title225: string;
    public title226: string;
    public title227: string;
    public title228: string;
    public title229: string;
    public title230: string;
    public title231: string;
    public title232: string;
    public title233: string;
    public title234: string;
    public title235: string;
    public title236: string;
    public title237: string;
    public title238: string;
    public title239: string;
    public title240: string;
    public title241: string;
    public title242: string;
    public title243: string;
    public title244: string;
    public title245: string;
    public title246: string;
    public title247: string;
    public title248: string;
    public title249: string;
    public title250: string;
    public title251: string;
    public title252: string;
    public title253: string;
    public title254: string;
    public title255: string;
    public title256: string;
    public title257: string;
    public title258: string;
    public title259: string;
    public title260: string;
    public title261: string;
    public title262: string;
    public title263: string;
    public title264: string;
    public title265: string;
    public title266: string;
    public title267: string;
    public title268: string;
    public title269: string;
    public title270: string;
    public title271: string;
    public title272: string;
    public title273: string;
    public title274: string;
    public title275: string;
    public title276: string;
    public title277: string;
    public title278: string;
    public title279: string;
    public title280: string;
    public title281: string;
    public title282: string;
    public title283: string;
    public title284: string;
    public title285: string;
    public title286: string;
    public title287: string;
    public title288: string;
    public title289: string;
    public title290: string;
    public title291: string;
    public title292: string;
    public title293: string;
    public title294: string;
    public title295: string;
    public title296: string;
    public title297: string;
    public title298: string;
    public title299: string;
    public title300: string;
    public title301: string;
    public title302: string;
    public title303: string;
    public title304: string;
    public title305: string;
    public title306: string;
    public title307: string;
    public title308: string;
    public title309: string;
    public title310: string;
    public title311: string;
    public title312: string;
    public title313: string;
    public title314: string;
    public title315: string;
    public title316: string;
    public title317: string;
    public title318: string;
    public title319: string;
    public title320: string;
    public title321: string;
    public title322: string;
    public title323: string;
    public title324: string;
    public title325: string;
    public title326: string;
    public title327: string;
    public title328: string;
    public title329: string;
    public title330: string;
    public title331: string;
    public title332: string;
    public title333: string;
    public title334: string;
    public title335: string;
    public title336: string;
    public title337: string;
    public title338: string;
    public title339: string;
    public title340: string;
    public title341: string;
    public title342: string;
    public title343: string;
    public title344: string;
    public title345: string;
    public title346: string;
    public title348: string;
    public title347: string;
    public title349: string;
    public title350: string;
    public title351: string;
    public title352: string;
    public title353: string;
    public title354: string;
    public title355: string;
    public title356: string;
    public title357: string;
    public title358: string;
    public title359: string;
    public title360: string;
    public title361: string;
    public title362: string;
    public title363: string;
    public title364: string;
    public title365: string;
    public title367: string;
    public title368: string;
    public title369: string;
    public title370: string;
    public title371: string;
    public title372: string;
    public title373: string;
    public title374: string;
    public title375: string;
    public title376: string;
    public title377: string;
    public title378: string;
    public title379: string;
    public title380: string;
    public title381: string;
    public title382: string;
    public title383: string;
    public title384: string;
    public title385: string;
    public title386: string;
    public title387: string;
    public title388: string;
    public title389: string;
    public title390: string;
    public title391: string;
    public title392: string;
    public title393: string;
    public title394: string;
    public title395: string;
    public title396: string;
    public title397: string;
    public title398: string;
    public title399: string;
    public title400: string;
    public title401: string;
    public title402: string;
    public title403: string;
    public title404: string;
    public title405: string;
    public title406: string;
    public title407: string;
    public title408: string;
    public title409: string;
    public title410: string;
    public title411: string;
    public title412: string;
    public title413: string;
    public title414: string;
    public title415: string;
    public title416: string;
    public title417: string;
    public title418: string;
    public title419: string;
    public title420: string;
    public title421: string;
    public title422: string;
    public title423: string;
    public title424: string;
    public title425: string;
    public title426: string;
    public title427: string;
    public title428: string;
    public title429: string;
    public title430: string;
    public title431: string;
    public title432: string;
    public title433: string;
    public title434: string;
    public title435: string;
    public title436: string;
    public title437: string;
    public title438: string;
    public title439: string;
    public title440: string;
    public title441: string;
    public title442: string;
    public title443: string;
    public title444: string;
    public title445: string;
    public title446: string;
    public title447: string;
    public title448: string;
    public title449: string;
    public title450: string;
    public title451: string;
    public title452: string;
    public title453: string;
    public title454: string;
    public title455: string;
    public title456: string;
    public title457: string;
    public title458: string;
    public title459: string;
    public title460: string;
    public title461: string;
    public title462: string;
    public title463: string;
    public title464: string;
    public title465: string;
    public title466: string;
    public title467: string;
    public title468: string;
    public title469: string;
    public title470: string;
    public title471: string;
    public title472: string;
    public title473: string;
    public title474: string;
    public title475: string;
    public title476: string;
    public title477: string;
    public title478: string;
    public title479: string;
    public title480: string;
    public title481: string;
    public title482: string;
    public title483: string;
    public title484: string;
    public title485: string;
    public title486: string;
    public title487: string;
    public title488: string;
    public title489: string;
    public title490: string;
    public title491: string;
    public title492: string;
    public title493: string;
    public title494: string;
    public title495: string;
    public title496: string;
    public title497: string;
    public title498: string;
    public title499: string;
    public title500: string;
    public title501: string;
    public title502: string;
    public title503: string;
    public title504: string;
    public title505: string;
    public title506: string;
    public title507: string;
    public title508: string;
    public title509: string;
    public title510: string;
    public title511: string;
    public title512: string;
    public title513: string;
    public title514: string;
    public title515: string;
    public title516: string;
    public title517: string;
    public title518: string;
    public title519: string;
    public title520: string;
    public title521: string;
    public title522: string;
    public title523: string;
    public title524: string;
    public title525: string;
    public title526: string;
    public title527: string;
    public title528: string;
    public title529: string;
    public title530: string;
    public title531: string;
    public title532: string;
    public title533: string;
    public title534: string;
    public title535: string;
    public title536: string;
    public title537: string;
    public title538: string;
    public title539: string;
    public title540: string;
    public title541: string;
    public title542: string;
    public title543: string;
    public title544: string;
    public title545: string;
    public title546: string;
    public title547: string;
    public title548: string;
    public title549: string;
    public title550: string;
    public title551: string;
    public title552: string;
    public title553: string;
    public title554: string;
    public title555: string;
    public title556: string;
    public title557: string;
    public title558: string;
    public title559: string;
    public title560: string;
    public title561: string;
    public title562: string;
    public tittle563: string;
    public tittle564: string;
    public tittle565: string;
    public tittle566: string;
    public tittle567: string;
    public tittle568: string;
    public tittle569: string;
    public tittle570: string;
    public title571: string;
    public title572: string;
    public title573: string;
    public title574: string;
    public title575: string;
    public title576: string;
    public title577: string;
    public title578: string;
    public title579: string;
    public title580: string;
    public title581: string;
    public title582: string;
    public title583: string;
    public title584: string;
    public title585: string;
    public title586: string;
    public title587: string;
    public title588: string;
    public title589: string;
    public title590: string;
    public title591: string;
    public title592: string;
    public title593: string;
    public title594: string;
    public title595: string;
    public title596: string;
    public title597: string;
    public title598: string;
    public title599: string;
    public title600: string;
    public title601: string;
    public title602: string;
    public title603: string;
    public title604: string;
    public title605: string;
    public title606: string;
    public title607: string;
    public title608: string;
    public title609: string;
    public title610: string;
    public title611: string;
    public title612: string;
    public title613: string;
    public title614: string;
    public title615: string;
    public title616: string;
    public title617: string;
    public title618: string;
    public title619: string;
    public title620: string;
    public title621: string;
    public title622: string;
    public title623: string;
    public title624: string;
    public title625: string;
    public title626: string;
    public title627: string;
    public title628: string;
    public title629: string;
    public title630: string;
    public title631: string;
    public title632: string;
    public title633: string;
    public title634: string;
    public title635: string;
    public title636: string;
    public title637: string;
    public title638: string;
    public title639: string;
    public title640: string;
    public title641: string;
    public title642: string;
    public title643: string;
    public title644: string;
    public title645: string;
    public title646: string;
    public title647: string;
    public title648: string;
    public title649: string;
    public title650: string;
    public title651: string;
    public title652: string;
    public title653: string;
    public title654: string;
    public title655: string;
    public title656: string;
    public title657: string;
    public title658: string;
    public title659: string;
    public title660: string;
    public title661: string;
    public title662: string;
    public title663: string;
    public title664: string;
    public title665: string;
    public title666: string;
    public title667: string;
    public title668: string;
    public title669: string;
    public title670: string;
    public title671: string;
    public title672: string;
    public title673: string;
    public title674: string;
    public title675: string;
    public title676: string;
    public title677: string;
    public title678: string;
    public title679: string;
    public title680: string;
    public title681: string;
    public title682: string;
    public title683: string;
    public title684: string;
    public title685: string;
    public title686: string;
    public title687: string;
    public title688: string;
    public title689: string;
    public title690: string;
    public title691: string;
    public title692: string;
    public title693: string;
    public title694: string;
    public title695: string;
    public title696: string;
    public title697: string;
    public title698: string;
    public title699: string;
    public title700: string;
    public title701: string;
    public title702: string;
    public title703: string;
    public title704: string;
    public title705: string;
    public title706: string;
    public title707: string;
    public title708: string;
    public title709: string;
    public title710: string;
    public title711: string;
    public title712: string;
    public title713: string;
    public title714: string;
    public title715: string;
    public title716: string;
    public title717: string;
    public title718: string;
    public title719: string;
    public title720: string;
    public title721: string;
    public title722: string;
    public title723: string;
    public title724: string;
    public title725: string;
    public title726: string;
    public title727: string;
    public title728: string;
    public title729: string;
    public title730: string;
    public title731: string;
    public title732: string;
    public title733: string;
    public title744: string;
    public title745: string;
    public title746: string;


    selectedDate: any;
    constructor(
        public modalCtrl: ModalController,
        public services: ServicesProvider,
        private _translate: TranslateService
    ) {
        this._translate.addLangs(["en", "ea"]);
        _translate.setDefaultLang('en');
        _translate.use('en');
    }

    async openAdvr(from) {
        var min = new Date(new Date().setTime(new Date().getTime() + 3600000));
        let CT = min.toISOString().split("T")[0] + "T" + min.toTimeString().split(" ")[0];

        if (from == "Lab") {
            window.localStorage['LabADD'] = CT;
        } else if (from == "DocList") {
            window.localStorage['DocADD'] = CT;
        } else if (from == "Home") {
            window.localStorage['HomeADD'] = CT;
        } else if (from == "Press") {
            window.localStorage['PresADD'] = CT;
        } else if (from == "Report") {
            window.localStorage['RepADD'] = CT;
        } else if (from == "BookRoom") {
            window.localStorage['BookADD'] = CT;
        } else if (from == "Nurse") {
            window.localStorage['NurseADD'] = CT;
        } else if (from == "Diet") {
            window.localStorage['DietADD'] = CT;
        } else if (from == "TrainCent") {
            window.localStorage['TrainCent'] = CT;
        } else if (from = "Physio") {
            window.localStorage['Physio'] = CT
        }

        let popover = await this.modalCtrl.create({
            component: AdvertisementPage,
            componentProps: {
                addImg: this.addImg,
                module: this.moduleName,
                VendorId: this.adddetails.ad_vendor_id,
                DocName: this.adddetails.vendorname,
                ClinicId: this.adddetails.ClinicId,
                Speciality: this.adddetails.speciality_id
            },
            cssClass: this.dynClass,
        });
        return await popover.present();
    }
    // getAdd(addType, from) {
    //     try {
    //         // window.localStorage['isAddOpened'] = 1;
    //         let today = new Date().toISOString().split("T")[0];
    //         let data = JSON.stringify({
    //             "ad_type": addType,
    //             "date": today
    //         });
    //         this.services.postRequestGndrl("admin/gettodayadlist", data).subscribe(res => {
    //             console.log("Advertisement Response -> ", res);
    //             if (res.length > 0) {
    //                 this.addImg = res[0].ad_path_name;
    //                 this.moduleName = res[0].ad_vendor_type_id;
    //                 this.adddetails = res[0];

    //                 if (res[0].ad_size == "1") {
    //                     this.dynClass = "advertisement1";
    //                 } else if (res[0].ad_size == "2") {
    //                     this.dynClass = "advertisement2";
    //                 }
    //                 this.openAdvr(from);
    //             } else {
    //                 this.addImg = '/assets/img/defAdd.png';
    //                 this.dynClass = "advertisement1";
    //                 this.openAdvr(from);
    //             }
    //             console.log("Class Name -> ", this.dynClass);
    //         }, (err) => {
    //             alert(err);
    //         });
    //     } catch (err) {
    //         alert(err);
    //     }
    // }

    initialiseTranslation(): void {
        this._translate.get('title1').subscribe((res: string) => {
            this.title1 = res;
        });
        this._translate.get('title2').subscribe((res: string) => {
            this.title2 = res;
        });
        this._translate.get('title3').subscribe((res: string) => {
            this.title3 = res;
        });
        this._translate.get('title4').subscribe((res: string) => {
            this.title4 = res;
        });
        this._translate.get('title5').subscribe((res: string) => {
            this.title5 = res;
        });
        this._translate.get('title6').subscribe((res: string) => {
            this.title6 = res;
        });
        this._translate.get('title7').subscribe((res: string) => {
            this.title7 = res;
        });
        this._translate.get('title8').subscribe((res: string) => {
            this.title8 = res;
        });
        this._translate.get('title9').subscribe((res: string) => {
            this.title9 = res;
        });
        this._translate.get('title10').subscribe((res: string) => {
            this.title10 = res;
        });
        this._translate.get('title11').subscribe((res: string) => {
            this.title11 = res;
        });
        this._translate.get('title12').subscribe((res: string) => {
            this.title12 = res;
        });
        this._translate.get('title13').subscribe((res: string) => {
            this.title13 = res;
        });
        this._translate.get('title14').subscribe((res: string) => {
            this.title14 = res;
        });
        this._translate.get('title15').subscribe((res: string) => {
            this.title15 = res;
        });
        this._translate.get('title16').subscribe((res: string) => {
            this.title16 = res;
        });
        this._translate.get('title17').subscribe((res: string) => {
            this.title17 = res;
        });
        this._translate.get('title18').subscribe((res: string) => {
            this.title18 = res;
        });
        this._translate.get('title19').subscribe((res: string) => {
            this.title19 = res;
        });
        this._translate.get('title20').subscribe((res: string) => {
            this.title20 = res;
        });
        this._translate.get('title21').subscribe((res: string) => {
            this.title21 = res;
        });
        this._translate.get('title22').subscribe((res: string) => {
            this.title22 = res;
        });
        this._translate.get('title23').subscribe((res: string) => {
            this.title23 = res;
        });
        this._translate.get('title24').subscribe((res: string) => {
            this.title24 = res;
        });
        this._translate.get('title25').subscribe((res: string) => {
            this.title25 = res;
        });
        this._translate.get('title26').subscribe((res: string) => {
            this.title26 = res;
        });
        this._translate.get('title27').subscribe((res: string) => {
            this.title27 = res;
        });
        this._translate.get('title28').subscribe((res: string) => {
            this.title28 = res;
        });
        this._translate.get('title29').subscribe((res: string) => {
            this.title29 = res;
        });
        this._translate.get('title30').subscribe((res: string) => {
            this.title30 = res;
        });
        this._translate.get('title31').subscribe((res: string) => {
            this.title31 = res;
        });
        this._translate.get('title32').subscribe((res: string) => {
            this.title32 = res;
        });
        this._translate.get('title33').subscribe((res: string) => {
            this.title33 = res;
        });
        this._translate.get('title34').subscribe((res: string) => {
            this.title34 = res;
        });
        this._translate.get('title35').subscribe((res: string) => {
            this.title35 = res;
        });
        this._translate.get('title36').subscribe((res: string) => {
            this.title36 = res;
        });
        this._translate.get('title37').subscribe((res: string) => {
            this.title37 = res;
        });
        this._translate.get('title38').subscribe((res: string) => {
            this.title38 = res;
        });
        this._translate.get('title39').subscribe((res: string) => {
            this.title39 = res;
        });
        this._translate.get('title40').subscribe((res: string) => {
            this.title40 = res;
        });
        this._translate.get('title41').subscribe((res: string) => {
            this.title41 = res;
        });
        this._translate.get('title42').subscribe((res: string) => {
            this.title42 = res;
        });
        this._translate.get('title43').subscribe((res: string) => {
            this.title43 = res;
        });
        this._translate.get('title44').subscribe((res: string) => {
            this.title44 = res;
        });
        this._translate.get('title45').subscribe((res: string) => {
            this.title45 = res;
        });
        this._translate.get('title46').subscribe((res: string) => {
            this.title46 = res;
        });
        this._translate.get('title47').subscribe((res: string) => {
            this.title47 = res;
        });
        this._translate.get('title48').subscribe((res: string) => {
            this.title48 = res;
        });
        this._translate.get('title49').subscribe((res: string) => {
            this.title49 = res;
        });
        this._translate.get('title50').subscribe((res: string) => {
            this.title50 = res;
        });
        this._translate.get('title51').subscribe((res: string) => {
            this.title51 = res;
        });
        this._translate.get('title52').subscribe((res: string) => {
            this.title52 = res;
        });
        this._translate.get('title53').subscribe((res: string) => {
            this.title53 = res;
        });
        this._translate.get('title54').subscribe((res: string) => {
            this.title54 = res;
        });
        this._translate.get('title55').subscribe((res: string) => {
            this.title55 = res;
        });
        this._translate.get('title56').subscribe((res: string) => {
            this.title56 = res;
        });
        this._translate.get('title57').subscribe((res: string) => {
            this.title57 = res;
        });
        this._translate.get('title58').subscribe((res: string) => {
            this.title58 = res;
        });
        this._translate.get('title59').subscribe((res: string) => {
            this.title59 = res;
        });
        this._translate.get('title60').subscribe((res: string) => {
            this.title60 = res;
        });
        this._translate.get('title61').subscribe((res: string) => {
            this.title61 = res;
        });
        this._translate.get('title62').subscribe((res: string) => {
            this.title62 = res;
        });
        this._translate.get('title63').subscribe((res: string) => {
            this.title63 = res;
        });
        this._translate.get('title64').subscribe((res: string) => {
            this.title64 = res;
        });
        this._translate.get('title65').subscribe((res: string) => {
            this.title65 = res;
        });
        this._translate.get('title66').subscribe((res: string) => {
            this.title66 = res;
        });
        this._translate.get('title67').subscribe((res: string) => {
            this.title67 = res;
        });
        this._translate.get('title68').subscribe((res: string) => {
            this.title68 = res;
        });
        this._translate.get('title69').subscribe((res: string) => {
            this.title69 = res;
        });
        this._translate.get('title70').subscribe((res: string) => {
            this.title70 = res;
        });
        this._translate.get('title71').subscribe((res: string) => {
            this.title71 = res;
        });
        this._translate.get('title72').subscribe((res: string) => {
            this.title72 = res;
        });
        this._translate.get('title73').subscribe((res: string) => {
            this.title73 = res;
        });
        this._translate.get('title74').subscribe((res: string) => {
            this.title74 = res;
        });
        this._translate.get('title75').subscribe((res: string) => {
            this.title75 = res;
        });
        this._translate.get('title76').subscribe((res: string) => {
            this.title76 = res;
        });
        this._translate.get('title77').subscribe((res: string) => {
            this.title77 = res;
        });
        this._translate.get('title78').subscribe((res: string) => {
            this.title78 = res;
        });
        this._translate.get('title79').subscribe((res: string) => {
            this.title79 = res;
        });
        this._translate.get('title80').subscribe((res: string) => {
            this.title80 = res;
        });
        this._translate.get('title81').subscribe((res: string) => {
            this.title81 = res;
        });
        this._translate.get('title82').subscribe((res: string) => {
            this.title82 = res;
        });
        this._translate.get('title83').subscribe((res: string) => {
            this.title83 = res;
        });
        this._translate.get('title84').subscribe((res: string) => {
            this.title84 = res;
        });
        this._translate.get('title85').subscribe((res: string) => {
            this.title85 = res;
        });
        this._translate.get('title86').subscribe((res: string) => {
            this.title86 = res;
        });
        this._translate.get('title87').subscribe((res: string) => {
            this.title87 = res;
        });
        this._translate.get('title88').subscribe((res: string) => {
            this.title88 = res;
        });
        this._translate.get('title89').subscribe((res: string) => {
            this.title89 = res;
        });
        this._translate.get('title90').subscribe((res: string) => {
            this.title90 = res;
        });
        this._translate.get('title91').subscribe((res: string) => {
            this.title91 = res;
        });
        this._translate.get('title92').subscribe((res: string) => {
            this.title92 = res;
        });
        this._translate.get('title93').subscribe((res: string) => {
            this.title93 = res;
        });
        this._translate.get('title94').subscribe((res: string) => {
            this.title94 = res;
        });
        this._translate.get('title95').subscribe((res: string) => {
            this.title95 = res;
        });
        this._translate.get('title96').subscribe((res: string) => {
            this.title96 = res;
        });
        this._translate.get('title97').subscribe((res: string) => {
            this.title97 = res;
        });
        this._translate.get('title98').subscribe((res: string) => {
            this.title98 = res;
        });
        this._translate.get('title99').subscribe((res: string) => {
            this.title99 = res;
        });
        this._translate.get('title100').subscribe((res: string) => {
            this.title100 = res;
        });
        this._translate.get('title101').subscribe((res: string) => {
            this.title101 = res;
        });
        this._translate.get('title102').subscribe((res: string) => {
            this.title102 = res;
        });
        this._translate.get('title103').subscribe((res: string) => {
            this.title103 = res;
        });
        this._translate.get('title104').subscribe((res: string) => {
            this.title104 = res;
        });
        this._translate.get('title105').subscribe((res: string) => {
            this.title105 = res;
        });
        this._translate.get('title106').subscribe((res: string) => {
            this.title106 = res;
        });
        this._translate.get('title107').subscribe((res: string) => {
            this.title107 = res;
        });
        this._translate.get('title108').subscribe((res: string) => {
            this.title108 = res;
        });
        this._translate.get('title109').subscribe((res: string) => {
            this.title109 = res;
        });
        this._translate.get('title110').subscribe((res: string) => {
            this.title110 = res;
        });
        this._translate.get('title111').subscribe((res: string) => {
            this.title111 = res;
        });
        this._translate.get('title112').subscribe((res: string) => {
            this.title112 = res;
        });
        this._translate.get('title113').subscribe((res: string) => {
            this.title113 = res;
        });
        this._translate.get('title114').subscribe((res: string) => {
            this.title114 = res;
        });
        this._translate.get('title115').subscribe((res: string) => {
            this.title115 = res;
        });
        this._translate.get('title116').subscribe((res: string) => {
            this.title116 = res;
        });
        this._translate.get('title117').subscribe((res: string) => {
            this.title117 = res;
        });
        this._translate.get('title118').subscribe((res: string) => {
            this.title118 = res;
        });
        this._translate.get('title119').subscribe((res: string) => {
            this.title119 = res;
        });
        this._translate.get('title120').subscribe((res: string) => {
            this.title120 = res;
        });
        this._translate.get('title121').subscribe((res: string) => {
            this.title121 = res;
        });
        this._translate.get('title122').subscribe((res: string) => {
            this.title122 = res;
        });
        this._translate.get('title123').subscribe((res: string) => {
            this.title123 = res;
        });
        this._translate.get('title124').subscribe((res: string) => {
            this.title124 = res;
        });
        this._translate.get('title125').subscribe((res: string) => {
            this.title125 = res;
        });
        this._translate.get('title126').subscribe((res: string) => {
            this.title126 = res;
        });
        this._translate.get('title127').subscribe((res: string) => {
            this.title127 = res;
        });
        this._translate.get('title128').subscribe((res: string) => {
            this.title128 = res;
        });
        this._translate.get('title129').subscribe((res: string) => {
            this.title129 = res;
        });
        this._translate.get('title130').subscribe((res: string) => {
            this.title130 = res;
        });
        this._translate.get('title131').subscribe((res: string) => {
            this.title131 = res;
        });
        this._translate.get('title132').subscribe((res: string) => {
            this.title132 = res;
        });
        this._translate.get('title133').subscribe((res: string) => {
            this.title133 = res;
        });
        this._translate.get('title134').subscribe((res: string) => {
            this.title134 = res;
        });
        this._translate.get('title135').subscribe((res: string) => {
            this.title135 = res;
        });
        this._translate.get('title136').subscribe((res: string) => {
            this.title136 = res;
        });
        this._translate.get('title137').subscribe((res: string) => {
            this.title137 = res;
        });
        this._translate.get('title138').subscribe((res: string) => {
            this.title138 = res;
        });
        this._translate.get('title139').subscribe((res: string) => {
            this.title139 = res;
        });
        this._translate.get('title140').subscribe((res: string) => {
            this.title140 = res;
        });
        this._translate.get('title141').subscribe((res: string) => {
            this.title141 = res;
        });
        this._translate.get('title142').subscribe((res: string) => {
            this.title142 = res;
        });
        this._translate.get('title143').subscribe((res: string) => {
            this.title143 = res;
        });
        this._translate.get('title144').subscribe((res: string) => {
            this.title144 = res;
        });
        this._translate.get('title145').subscribe((res: string) => {
            this.title145 = res;
        });
        this._translate.get('title146').subscribe((res: string) => {
            this.title146 = res;
        });
        this._translate.get('title147').subscribe((res: string) => {
            this.title147 = res;
        });
        this._translate.get('title148').subscribe((res: string) => {
            this.title148 = res;
        });
        this._translate.get('title149').subscribe((res: string) => {
            this.title149 = res;
        });
        this._translate.get('title150').subscribe((res: string) => {
            this.title150 = res;
        });
        this._translate.get('title151').subscribe((res: string) => {
            this.title151 = res;
        });
        this._translate.get('title152').subscribe((res: string) => {
            this.title152 = res;
        });
        this._translate.get('title153').subscribe((res: string) => {
            this.title153 = res;
        });
        this._translate.get('title154').subscribe((res: string) => {
            this.title154 = res;
        });
        this._translate.get('title155').subscribe((res: string) => {
            this.title155 = res;
        });
        this._translate.get('title156').subscribe((res: string) => {
            this.title156 = res;
        });
        this._translate.get('title157').subscribe((res: string) => {
            this.title157 = res;
        });
        this._translate.get('title158').subscribe((res: string) => {
            this.title158 = res;
        });
        this._translate.get('title159').subscribe((res: string) => {
            this.title159 = res;
        });
        this._translate.get('title160').subscribe((res: string) => {
            this.title160 = res;
        });
        this._translate.get('title161').subscribe((res: string) => {
            this.title161 = res;
        });
        this._translate.get('title162').subscribe((res: string) => {
            this.title162 = res;
        });
        this._translate.get('title163').subscribe((res: string) => {
            this.title163 = res;
        });
        this._translate.get('title').subscribe((res: string) => {
            this.title = res;
        });
        this._translate.get('title164').subscribe((res: string) => {
            this.title164 = res;
        });
        this._translate.get('title165').subscribe((res: string) => {
            this.title165 = res;
        });
        this._translate.get('title166').subscribe((res: string) => {
            this.title166 = res;
        });
        this._translate.get('title167').subscribe((res: string) => {
            this.title167 = res;
        });
        this._translate.get('title168').subscribe((res: string) => {
            this.title168 = res;
        });
        this._translate.get('title169').subscribe((res: string) => {
            this.title169 = res;
        });
        this._translate.get('title170').subscribe((res: string) => {
            this.title170 = res;
        });
        this._translate.get('title171').subscribe((res: string) => {
            this.title171 = res;
        });
        this._translate.get('title172').subscribe((res: string) => {
            this.title172 = res;
        });
        this._translate.get('title173').subscribe((res: string) => {
            this.title173 = res;
        });
        this._translate.get('title174').subscribe((res: string) => {
            this.title174 = res;
        });
        this._translate.get('title175').subscribe((res: string) => {
            this.title175 = res;
        });
        this._translate.get('title176').subscribe((res: string) => {
            this.title176 = res;
        });
        this._translate.get('title177').subscribe((res: string) => {
            this.title177 = res;
        });
        this._translate.get('title178').subscribe((res: string) => {
            this.title178 = res;
        });
        this._translate.get('title179').subscribe((res: string) => {
            this.title179 = res;
        });
        this._translate.get('title180').subscribe((res: string) => {
            this.title180 = res;
        });
        this._translate.get('title181').subscribe((res: string) => {
            this.title181 = res;
        });
        this._translate.get('title182').subscribe((res: string) => {
            this.title182 = res;
        });
        this._translate.get('title183').subscribe((res: string) => {
            this.title183 = res;
        });
        this._translate.get('title184').subscribe((res: string) => {
            this.title184 = res;
        });
        this._translate.get('title185').subscribe((res: string) => {
            this.title185 = res;
        });
        this._translate.get('title186').subscribe((res: string) => {
            this.title186 = res;
        });
        this._translate.get('title187').subscribe((res: string) => {
            this.title187 = res;
        });
        this._translate.get('title188').subscribe((res: string) => {
            this.title188 = res;
        });
        this._translate.get('title189').subscribe((res: string) => {
            this.title189 = res;
        });
        this._translate.get('title190').subscribe((res: string) => {
            this.title190 = res;
        });
        this._translate.get('title191').subscribe((res: string) => {
            this.title191 = res;
        });
        this._translate.get('title192').subscribe((res: string) => {
            this.title192 = res;
        });
        this._translate.get('title193').subscribe((res: string) => {
            this.title193 = res;
        });
        this._translate.get('title194').subscribe((res: string) => {
            this.title194 = res;
        });
        this._translate.get('title195').subscribe((res: string) => {
            this.title195 = res;
        });
        this._translate.get('title196').subscribe((res: string) => {
            this.title196 = res;
        });
        this._translate.get('title197').subscribe((res: string) => {
            this.title197 = res;
        });
        this._translate.get('title198').subscribe((res: string) => {
            this.title198 = res;
        });
        this._translate.get('title199').subscribe((res: string) => {
            this.title199 = res;
        });
        this._translate.get('title200').subscribe((res: string) => {
            this.title200 = res;
        });
        this._translate.get('title201').subscribe((res: string) => {
            this.title201 = res;
        });
        this._translate.get('title202').subscribe((res: string) => {
            this.title202 = res;
        });
        this._translate.get('title203').subscribe((res: string) => {
            this.title203 = res;
        });
        this._translate.get('title204').subscribe((res: string) => {
            this.title204 = res;
        });
        this._translate.get('title205').subscribe((res: string) => {
            this.title205 = res;
        });
        this._translate.get('title206').subscribe((res: string) => {
            this.title206 = res;
        });
        this._translate.get('title207').subscribe((res: string) => {
            this.title207 = res;
        });
        this._translate.get('title208').subscribe((res: string) => {
            this.title208 = res;
        });
        this._translate.get('title209').subscribe((res: string) => {
            this.title209 = res;
        });
        this._translate.get('title210').subscribe((res: string) => {
            this.title210 = res;
        });
        this._translate.get('title211').subscribe((res: string) => {
            this.title211 = res;
        });
        this._translate.get('title212').subscribe((res: string) => {
            this.title212 = res;
        });
        this._translate.get('title213').subscribe((res: string) => {
            this.title213 = res;
        });
        this._translate.get('title214').subscribe((res: string) => {
            this.title214 = res;
        });
        this._translate.get('title215').subscribe((res: string) => {
            this.title215 = res;
        });
        this._translate.get('title216').subscribe((res: string) => {
            this.title216 = res;
        });
        this._translate.get('title217').subscribe((res: string) => {
            this.title217 = res;
        });
        this._translate.get('title218').subscribe((res: string) => {
            this.title218 = res;
        });
        this._translate.get('title219').subscribe((res: string) => {
            this.title219 = res;
        });
        this._translate.get('title220').subscribe((res: string) => {
            this.title220 = res;
        });
        this._translate.get('title221').subscribe((res: string) => {
            this.title221 = res;
        });
        this._translate.get('title222').subscribe((res: string) => {
            this.title222 = res;
        });
        this._translate.get('title223').subscribe((res: string) => {
            this.title223 = res;
        });
        this._translate.get('title224').subscribe((res: string) => {
            this.title224 = res;
        });
        this._translate.get('title225').subscribe((res: string) => {
            this.title225 = res;
        });
        this._translate.get('title226').subscribe((res: string) => {
            this.title226 = res;
        });
        this._translate.get('title227').subscribe((res: string) => {
            this.title227 = res;
        });
        this._translate.get('title228').subscribe((res: string) => {
            this.title228 = res;
        });
        this._translate.get('title229').subscribe((res: string) => {
            this.title229 = res;
        });
        this._translate.get('title230').subscribe((res: string) => {
            this.title230 = res;
        });
        this._translate.get('title231').subscribe((res: string) => {
            this.title231 = res;
        });
        this._translate.get('title232').subscribe((res: string) => {
            this.title232 = res;
        });
        this._translate.get('title233').subscribe((res: string) => {
            this.title233 = res;
        });
        this._translate.get('title234').subscribe((res: string) => {
            this.title234 = res;
        });
        this._translate.get('title235').subscribe((res: string) => {
            this.title235 = res;
        });
        this._translate.get('title236').subscribe((res: string) => {
            this.title236 = res;
        });
        this._translate.get('title237').subscribe((res: string) => {
            this.title237 = res;
        });
        this._translate.get('title238').subscribe((res: string) => {
            this.title238 = res;
        });
        this._translate.get('title239').subscribe((res: string) => {
            this.title239 = res;
        });
        this._translate.get('title240').subscribe((res: string) => {
            this.title240 = res;
        });
        this._translate.get('title240').subscribe((res: string) => {
            this.title240 = res;
        });
        this._translate.get('title241').subscribe((res: string) => {
            this.title241 = res;
        });
        this._translate.get('title242').subscribe((res: string) => {
            this.title242 = res;
        });
        this._translate.get('title243').subscribe((res: string) => {
            this.title243 = res;
        });
        this._translate.get('title244').subscribe((res: string) => {
            this.title244 = res;
        });
        this._translate.get('title245').subscribe((res: string) => {
            this.title245 = res;
        });
        this._translate.get('title246').subscribe((res: string) => {
            this.title246 = res;
        });
        this._translate.get('title247').subscribe((res: string) => {
            this.title247 = res;
        });
        this._translate.get('title248').subscribe((res: string) => {
            this.title248 = res;
        });
        this._translate.get('title249').subscribe((res: string) => {
            this.title249 = res;
        });
        this._translate.get('title250').subscribe((res: string) => {
            this.title250 = res;
        });
        this._translate.get('title251').subscribe((res: string) => {
            this.title251 = res;
        });
        this._translate.get('title252').subscribe((res: string) => {
            this.title252 = res;
        });
        this._translate.get('title253').subscribe((res: string) => {
            this.title253 = res;
        });
        this._translate.get('title254').subscribe((res: string) => {
            this.title254 = res;
        });
        this._translate.get('title255').subscribe((res: string) => {
            this.title255 = res;
        });
        this._translate.get('title256').subscribe((res: string) => {
            this.title256 = res;
        });
        this._translate.get('title257').subscribe((res: string) => {
            this.title257 = res;
        });
        this._translate.get('title258').subscribe((res: string) => {
            this.title258 = res;
        });
        this._translate.get('title259').subscribe((res: string) => {
            this.title259 = res;
        });
        this._translate.get('title260').subscribe((res: string) => {
            this.title260 = res;
        });
        this._translate.get('title261').subscribe((res: string) => {
            this.title261 = res;
        });
        this._translate.get('title262').subscribe((res: string) => {
            this.title262 = res;
        });
        this._translate.get('title263').subscribe((res: string) => {
            this.title263 = res;
        });
        this._translate.get('title264').subscribe((res: string) => {
            this.title264 = res;
        });
        this._translate.get('title265').subscribe((res: string) => {
            this.title265 = res;
        });
        this._translate.get('title266').subscribe((res: string) => {
            this.title266 = res;
        });
        this._translate.get('title267').subscribe((res: string) => {
            this.title267 = res;
        });
        this._translate.get('title268').subscribe((res: string) => {
            this.title268 = res;
        });
        this._translate.get('title269').subscribe((res: string) => {
            this.title269 = res;
        });
        this._translate.get('title270').subscribe((res: string) => {
            this.title270 = res;
        });
        this._translate.get('title271').subscribe((res: string) => {
            this.title271 = res;
        });
        this._translate.get('title272').subscribe((res: string) => {
            this.title272 = res;
        });
        this._translate.get('title273').subscribe((res: string) => {
            this.title273 = res;
        });
        this._translate.get('title274').subscribe((res: string) => {
            this.title274 = res;
        });
        this._translate.get('title275').subscribe((res: string) => {
            this.title275 = res;
        });
        this._translate.get('title276').subscribe((res: string) => {
            this.title276 = res;
        });
        this._translate.get('title277').subscribe((res: string) => {
            this.title277 = res;
        });
        this._translate.get('title278').subscribe((res: string) => {
            this.title278 = res;
        });
        this._translate.get('title279').subscribe((res: string) => {
            this.title279 = res;
        });
        this._translate.get('title280').subscribe((res: string) => {
            this.title280 = res;
        });
        this._translate.get('title281').subscribe((res: string) => {
            this.title281 = res;
        });
        this._translate.get('title282').subscribe((res: string) => {
            this.title282 = res;
        });
        this._translate.get('title283').subscribe((res: string) => {
            this.title283 = res;
        });
        this._translate.get('title284').subscribe((res: string) => {
            this.title284 = res;
        });
        this._translate.get('title285').subscribe((res: string) => {
            this.title285 = res;
        });
        this._translate.get('title286').subscribe((res: string) => {
            this.title286 = res;
        });
        this._translate.get('title287').subscribe((res: string) => {
            this.title287 = res;
        });
        this._translate.get('title288').subscribe((res: string) => {
            this.title288 = res;
        });
        this._translate.get('title289').subscribe((res: string) => {
            this.title289 = res;
        });
        this._translate.get('title290').subscribe((res: string) => {
            this.title290 = res;
        });
        this._translate.get('title291').subscribe((res: string) => {
            this.title291 = res;
        });
        this._translate.get('title292').subscribe((res: string) => {
            this.title292 = res;
        });
        this._translate.get('title293').subscribe((res: string) => {
            this.title293 = res;
        });
        this._translate.get('title294').subscribe((res: string) => {
            this.title294 = res;
        });
        this._translate.get('title295').subscribe((res: string) => {
            this.title295 = res;
        });
        this._translate.get('title296').subscribe((res: string) => {
            this.title296 = res;
        });
        this._translate.get('title297').subscribe((res: string) => {
            this.title297 = res;
        });
        this._translate.get('title298').subscribe((res: string) => {
            this.title298 = res;
        });
        this._translate.get('title299').subscribe((res: string) => {
            this.title299 = res;
        });
        this._translate.get('title300').subscribe((res: string) => {
            this.title300 = res;
        });
        this._translate.get('title301').subscribe((res: string) => {
            this.title301 = res;
        });
        this._translate.get('title302').subscribe((res: string) => {
            this.title302 = res;
        });
        this._translate.get('title303').subscribe((res: string) => {
            this.title303 = res;
        });
        this._translate.get('title304').subscribe((res: string) => {
            this.title304 = res;
        });
        this._translate.get('title305').subscribe((res: string) => {
            this.title305 = res;
        });
        this._translate.get('title306').subscribe((res: string) => {
            this.title306 = res;
        });
        this._translate.get('title307').subscribe((res: string) => {
            this.title307 = res;
        });
        this._translate.get('title308').subscribe((res: string) => {
            this.title308 = res;
        });
        this._translate.get('title309').subscribe((res: string) => {
            this.title309 = res;
        });
        this._translate.get('title310').subscribe((res: string) => {
            this.title310 = res;
        });
        this._translate.get('title311').subscribe((res: string) => {
            this.title311 = res;
        });
        this._translate.get('title312').subscribe((res: string) => {
            this.title312 = res;
        });
        this._translate.get('title313').subscribe((res: string) => {
            this.title313 = res;
        });
        this._translate.get('title314').subscribe((res: string) => {
            this.title314 = res;
        });
        this._translate.get('title315').subscribe((res: string) => {
            this.title315 = res;
        });
        this._translate.get('title316').subscribe((res: string) => {
            this.title316 = res;
        });
        this._translate.get('title317').subscribe((res: string) => {
            this.title317 = res;
        });
        this._translate.get('title318').subscribe((res: string) => {
            this.title318 = res;
        });
        this._translate.get('title319').subscribe((res: string) => {
            this.title319 = res;
        });
        this._translate.get('title320').subscribe((res: string) => {
            this.title320 = res;
        });
        this._translate.get('title321').subscribe((res: string) => {
            this.title321 = res;
        });
        this._translate.get('title322').subscribe((res: string) => {
            this.title322 = res;
        });
        this._translate.get('title323').subscribe((res: string) => {
            this.title323 = res;
        });
        this._translate.get('title324').subscribe((res: string) => {
            this.title324 = res;
        });
        this._translate.get('title325').subscribe((res: string) => {
            this.title325 = res;
        });
        this._translate.get('title326').subscribe((res: string) => {
            this.title326 = res;
        });
        this._translate.get('title327').subscribe((res: string) => {
            this.title327 = res;
        });
        this._translate.get('title328').subscribe((res: string) => {
            this.title328 = res;
        });
        this._translate.get('title329').subscribe((res: string) => {
            this.title329 = res;
        });
        this._translate.get('title330').subscribe((res: string) => {
            this.title330 = res;
        });
        this._translate.get('title331').subscribe((res: string) => {
            this.title331 = res;
        });
        this._translate.get('title332').subscribe((res: string) => {
            this.title332 = res;
        });
        this._translate.get('title333').subscribe((res: string) => {
            this.title333 = res;
        });
        this._translate.get('title334').subscribe((res: string) => {
            this.title334 = res;
        });
        this._translate.get('title335').subscribe((res: string) => {
            this.title335 = res;
        });
        this._translate.get('title336').subscribe((res: string) => {
            this.title336 = res;
        });
        this._translate.get('title337').subscribe((res: string) => {
            this.title337 = res;
        });
        this._translate.get('title338').subscribe((res: string) => {
            this.title338 = res;
        });
        this._translate.get('title339').subscribe((res: string) => {
            this.title339 = res;
        });
        this._translate.get('title340').subscribe((res: string) => {
            this.title340 = res;
        });
        this._translate.get('title341').subscribe((res: string) => {
            this.title341 = res;
        });
        this._translate.get('title342').subscribe((res: string) => {
            this.title342 = res;
        });
        this._translate.get('title343').subscribe((res: string) => {
            this.title343 = res;
        });
        this._translate.get('title344').subscribe((res: string) => {
            this.title344 = res;
        });
        this._translate.get('title345').subscribe((res: string) => {
            this.title345 = res;
        });
        this._translate.get('title346').subscribe((res: string) => {
            this.title346 = res;
        });
        this._translate.get('title347').subscribe((res: string) => {
            this.title347 = res;
        });
        this._translate.get('title348').subscribe((res: string) => {
            this.title348 = res;
        });
        this._translate.get('title349').subscribe((res: string) => {
            this.title349 = res;
        });
        this._translate.get('title350').subscribe((res: string) => {
            this.title350 = res;
        });
        this._translate.get('title351').subscribe((res: string) => {
            this.title351 = res;
        });
        this._translate.get('title352').subscribe((res: string) => {
            this.title352 = res;
        });
        this._translate.get('title353').subscribe((res: string) => {
            this.title353 = res;
        });
        this._translate.get('title354').subscribe((res: string) => {
            this.title354 = res;
        });
        this._translate.get('title355').subscribe((res: string) => {
            this.title355 = res;
        });
        this._translate.get('title356').subscribe((res: string) => {
            this.title356 = res;
        });
        this._translate.get('title357').subscribe((res: string) => {
            this.title357 = res;
        });
        this._translate.get('title358').subscribe((res: string) => {
            this.title358 = res;
        });
        this._translate.get('title359').subscribe((res: string) => {
            this.title359 = res;
        });
        this._translate.get('title360').subscribe((res: string) => {
            this.title360 = res;
        });
        this._translate.get('title361').subscribe((res: string) => {
            this.title361 = res;
        });
        this._translate.get('title362').subscribe((res: string) => {
            this.title362 = res;
        });
        this._translate.get('title363').subscribe((res: string) => {
            this.title363 = res;
        });
        this._translate.get('title364').subscribe((res: string) => {
            this.title364 = res;
        });
        this._translate.get('title365').subscribe((res: string) => {
            this.title365 = res;
        });
        this._translate.get('title367').subscribe((res: string) => {
            this.title367 = res;
        });
        this._translate.get('title368').subscribe((res: string) => {
            this.title368 = res;
        });
        this._translate.get('title369').subscribe((res: string) => {
            this.title369 = res;
        });
        this._translate.get('title370').subscribe((res: string) => {
            this.title370 = res;
        });
        this._translate.get('title371').subscribe((res: string) => {
            this.title371 = res;
        });
        this._translate.get('title372').subscribe((res: string) => {
            this.title372 = res;
        });
        this._translate.get('title373').subscribe((res: string) => {
            this.title373 = res;
        });
        this._translate.get('title374').subscribe((res: string) => {
            this.title374 = res;
        });
        this._translate.get('title375').subscribe((res: string) => {
            this.title375 = res;
        });
        this._translate.get('title376').subscribe((res: string) => {
            this.title376 = res;
        });
        this._translate.get('title377').subscribe((res: string) => {
            this.title377 = res;
        });
        this._translate.get('title378').subscribe((res: string) => {
            this.title378 = res;
        });
        this._translate.get('title379').subscribe((res: string) => {
            this.title379 = res;
        });
        this._translate.get('title380').subscribe((res: string) => {
            this.title380 = res;
        });
        this._translate.get('title381').subscribe((res: string) => {
            this.title381 = res;
        });
        this._translate.get('title382').subscribe((res: string) => {
            this.title382 = res;
        });
        this._translate.get('title383').subscribe((res: string) => {
            this.title383 = res;
        });
        this._translate.get('title384').subscribe((res: string) => {
            this.title384 = res;
        });
        this._translate.get('title385').subscribe((res: string) => {
            this.title385 = res;
        });
        this._translate.get('title386').subscribe((res: string) => {
            this.title386 = res;
        });
        this._translate.get('title387').subscribe((res: string) => {
            this.title387 = res;
        });
        this._translate.get('title388').subscribe((res: string) => {
            this.title388 = res;
        });
        this._translate.get('title389').subscribe((res: string) => {
            this.title389 = res;
        });
        this._translate.get('title390').subscribe((res: string) => {
            this.title390 = res;
        });
        this._translate.get('title391').subscribe((res: string) => {
            this.title391 = res;
        });
        this._translate.get('title392').subscribe((res: string) => {
            this.title392 = res;
        });
        this._translate.get('title393').subscribe((res: string) => {
            this.title393 = res;
        });
        this._translate.get('title394').subscribe((res: string) => {
            this.title394 = res;
        });
        this._translate.get('title395').subscribe((res: string) => {
            this.title395 = res;
        });
        this._translate.get('title396').subscribe((res: string) => {
            this.title396 = res;
        });
        this._translate.get('title397').subscribe((res: string) => {
            this.title397 = res;
        });
        this._translate.get('title398').subscribe((res: string) => {
            this.title398 = res;
        });
        this._translate.get('title399').subscribe((res: string) => {
            this.title399 = res;
        });
        this._translate.get('title400').subscribe((res: string) => {
            this.title400 = res;
        });
        this._translate.get('title401').subscribe((res: string) => {
            this.title401 = res;
        });
        this._translate.get('title402').subscribe((res: string) => {
            this.title402 = res;
        });
        this._translate.get('title403').subscribe((res: string) => {
            this.title403 = res;
        });
        this._translate.get('title404').subscribe((res: string) => {
            this.title404 = res;
        });
        this._translate.get('title405').subscribe((res: string) => {
            this.title405 = res;
        });
        this._translate.get('title406').subscribe((res: string) => {
            this.title406 = res;
        });
        this._translate.get('title407').subscribe((res: string) => {
            this.title407 = res;
        });
        this._translate.get('title408').subscribe((res: string) => {
            this.title408 = res;
        });
        this._translate.get('title409').subscribe((res: string) => {
            this.title409 = res;
        });
        this._translate.get('title410').subscribe((res: string) => {
            this.title410 = res;
        });
        this._translate.get('title411').subscribe((res: string) => {
            this.title411 = res;
        });
        this._translate.get('title412').subscribe((res: string) => {
            this.title412 = res;
        });
        this._translate.get('title413').subscribe((res: string) => {
            this.title413 = res;
        });
        this._translate.get('title414').subscribe((res: string) => {
            this.title414 = res;
        });
        this._translate.get('title415').subscribe((res: string) => {
            this.title415 = res;
        });
        this._translate.get('title416').subscribe((res: string) => {
            this.title416 = res;
        });
        this._translate.get('title417').subscribe((res: string) => {
            this.title417 = res;
        });
        this._translate.get('title418').subscribe((res: string) => {
            this.title418 = res;
        });
        this._translate.get('title419').subscribe((res: string) => {
            this.title419 = res;
        });
        this._translate.get('title420').subscribe((res: string) => {
            this.title420 = res;
        });
        this._translate.get('title421').subscribe((res: string) => {
            this.title421 = res;
        });
        this._translate.get('title422').subscribe((res: string) => {
            this.title422 = res;
        });
        this._translate.get('title423').subscribe((res: string) => {
            this.title423 = res;
        });
        this._translate.get('title424').subscribe((res: string) => {
            this.title424 = res;
        });
        this._translate.get('title425').subscribe((res: string) => {
            this.title425 = res;
        });
        this._translate.get('title426').subscribe((res: string) => {
            this.title426 = res;
        });
        this._translate.get('title427').subscribe((res: string) => {
            this.title427 = res;
        });
        this._translate.get('title428').subscribe((res: string) => {
            this.title428 = res;
        });
        this._translate.get('title429').subscribe((res: string) => {
            this.title429 = res;
        });
        this._translate.get('title430').subscribe((res: string) => {
            this.title430 = res;
        });
        this._translate.get('title431').subscribe((res: string) => {
            this.title431 = res;
        });
        this._translate.get('title432').subscribe((res: string) => {
            this.title432 = res;
        });
        this._translate.get('title433').subscribe((res: string) => {
            this.title433 = res;
        });
        this._translate.get('title434').subscribe((res: string) => {
            this.title434 = res;
        });
        this._translate.get('title435').subscribe((res: string) => {
            this.title435 = res;
        });
        this._translate.get('title436').subscribe((res: string) => {
            this.title436 = res;
        });
        this._translate.get('title437').subscribe((res: string) => {
            this.title437 = res;
        });
        this._translate.get('title438').subscribe((res: string) => {
            this.title438 = res;
        });
        this._translate.get('title438').subscribe((res: string) => {
            this.title = res;
        });
        this._translate.get('title439').subscribe((res: string) => {
            this.title439 = res;
        });
        this._translate.get('title440').subscribe((res: string) => {
            this.title440 = res;
        });
        this._translate.get('title441').subscribe((res: string) => {
            this.title441 = res;
        });
        this._translate.get('title442').subscribe((res: string) => {
            this.title442 = res;
        });
        this._translate.get('title443').subscribe((res: string) => {
            this.title443 = res;
        });
        this._translate.get('title444').subscribe((res: string) => {
            this.title444 = res;
        });
        this._translate.get('title445').subscribe((res: string) => {
            this.title445 = res;
        });
        this._translate.get('title446').subscribe((res: string) => {
            this.title446 = res;
        });
        this._translate.get('title447').subscribe((res: string) => {
            this.title447 = res;
        });
        this._translate.get('title448').subscribe((res: string) => {
            this.title448 = res;
        });
        this._translate.get('title449').subscribe((res: string) => {
            this.title449 = res;
        });
        this._translate.get('title450').subscribe((res: string) => {
            this.title450 = res;
        });
        this._translate.get('title451').subscribe((res: string) => {
            this.title451 = res;
        });
        this._translate.get('title452').subscribe((res: string) => {
            this.title452 = res;
        });
        this._translate.get('title453').subscribe((res: string) => {
            this.title453 = res;
        });
        this._translate.get('title454').subscribe((res: string) => {
            this.title454 = res;
        });
        this._translate.get('title455').subscribe((res: string) => {
            this.title455 = res;
        });
        this._translate.get('title456').subscribe((res: string) => {
            this.title456 = res;
        });
        this._translate.get('title457').subscribe((res: string) => {
            this.title457 = res;
        })
        this._translate.get('title458').subscribe((res: string) => {
            this.title458 = res;
        });
        this._translate.get('title459').subscribe((res: string) => {
            this.title459 = res;
        });
        this._translate.get('title460').subscribe((res: string) => {
            this.title460 = res;
        });
        this._translate.get('title461').subscribe((res: string) => {
            this.title461 = res;
        });
        this._translate.get('title462').subscribe((res: string) => {
            this.title462 = res;
        });
        this._translate.get('title463').subscribe((res: string) => {
            this.title463 = res;
        });
        this._translate.get('title464').subscribe((res: string) => {
            this.title464 = res;
        });
        this._translate.get('title465').subscribe((res: string) => {
            this.title465 = res;
        });
        this._translate.get('title466').subscribe((res: string) => {
            this.title466 = res;
        });
        this._translate.get('title467').subscribe((res: string) => {
            this.title467 = res;
        });
        this._translate.get('title468').subscribe((res: string) => {
            this.title468 = res;
        });
        this._translate.get('title469').subscribe((res: string) => {
            this.title469 = res;
        });
        this._translate.get('title470').subscribe((res: string) => {
            this.title470 = res;
        });
        this._translate.get('title471').subscribe((res: string) => {
            this.title471 = res;
        });
        this._translate.get('title472').subscribe((res: string) => {
            this.title472 = res;
        });
        this._translate.get('title473').subscribe((res: string) => {
            this.title473 = res;
        });
        this._translate.get('title474').subscribe((res: string) => {
            this.title474 = res;
        });
        this._translate.get('title475').subscribe((res: string) => {
            this.title475 = res;
        });
        this._translate.get('title476').subscribe((res: string) => {
            this.title476 = res;
        });
        this._translate.get('title477').subscribe((res: string) => {
            this.title477 = res;
        });
        this._translate.get('title478').subscribe((res: string) => {
            this.title478 = res;
        });
        this._translate.get('title479').subscribe((res: string) => {
            this.title479 = res;
        });
        this._translate.get('title480').subscribe((res: string) => {
            this.title480 = res;
        });
        this._translate.get('title481').subscribe((res: string) => {
            this.title481 = res;
        });
        this._translate.get('title482').subscribe((res: string) => {
            this.title482 = res;
        });
        this._translate.get('title483').subscribe((res: string) => {
            this.title483 = res;
        });
        this._translate.get('title484').subscribe((res: string) => {
            this.title484 = res;
        });
        this._translate.get('title485').subscribe((res: string) => {
            this.title485 = res;
        });
        this._translate.get('title486').subscribe((res: string) => {
            this.title486 = res;
        });
        this._translate.get('title487').subscribe((res: string) => {
            this.title487 = res;
        });
        this._translate.get('title488').subscribe((res: string) => {
            this.title488 = res;
        });
        this._translate.get('title489').subscribe((res: string) => {
            this.title489 = res;
        });
        this._translate.get('title490').subscribe((res: string) => {
            this.title490 = res;
        });
        this._translate.get('title491').subscribe((res: string) => {
            this.title491 = res;
        });
        this._translate.get('title492').subscribe((res: string) => {
            this.title492 = res;
        });
        this._translate.get('title493').subscribe((res: string) => {
            this.title493 = res;
        });
        this._translate.get('title494').subscribe((res: string) => {
            this.title494 = res;
        });
        this._translate.get('title495').subscribe((res: string) => {
            this.title495 = res;
        });
        this._translate.get('title496').subscribe((res: string) => {
            this.title496 = res;
        });
        this._translate.get('title497').subscribe((res: string) => {
            this.title497 = res;
        });
        this._translate.get('title498').subscribe((res: string) => {
            this.title498 = res;
        });
        this._translate.get('title499').subscribe((res: string) => {
            this.title499 = res;
        });
        this._translate.get('title500').subscribe((res: string) => {
            this.title500 = res;
        });
        this._translate.get('title501').subscribe((res: string) => {
            this.title501 = res;
        });
        this._translate.get('title502').subscribe((res: string) => {
            this.title502 = res;
        });
        this._translate.get('title503').subscribe((res: string) => {
            this.title503 = res;
        });
        this._translate.get('title504').subscribe((res: string) => {
            this.title504 = res;
        });
        this._translate.get('title505').subscribe((res: string) => {
            this.title505 = res;
        });
        this._translate.get('title506').subscribe((res: string) => {
            this.title506 = res;
        });
        this._translate.get('title507').subscribe((res: string) => {
            this.title507 = res;
        });
        this._translate.get('title508').subscribe((res: string) => {
            this.title508 = res;
        });
        this._translate.get('title509').subscribe((res: string) => {
            this.title509 = res;
        });
        this._translate.get('title510').subscribe((res: string) => {
            this.title510 = res;
        });
        this._translate.get('title511').subscribe((res: string) => {
            this.title511 = res;
        });
        this._translate.get('title512').subscribe((res: string) => {
            this.title512 = res;
        });
        this._translate.get('title513').subscribe((res: string) => {
            this.title513 = res;
        });
        this._translate.get('title514').subscribe((res: string) => {
            this.title514 = res;
        });
        this._translate.get('title515').subscribe((res: string) => {
            this.title515 = res;
        });
        this._translate.get('title516').subscribe((res: string) => {
            this.title516 = res;
        });
        this._translate.get('title517').subscribe((res: string) => {
            this.title517 = res;
        });
        this._translate.get('title518').subscribe((res: string) => {
            this.title518 = res;
        });
        this._translate.get('title519').subscribe((res: string) => {
            this.title519 = res;
        });
        this._translate.get('title520').subscribe((res: string) => {
            this.title520 = res;
        });
        this._translate.get('title521').subscribe((res: string) => {
            this.title521 = res;
        });
        this._translate.get('title522').subscribe((res: string) => {
            this.title522 = res;
        });
        this._translate.get('title523').subscribe((res: string) => {
            this.title523 = res;
        });
        this._translate.get('title524').subscribe((res: string) => {
            this.title524 = res;
        });
        this._translate.get('title525').subscribe((res: string) => {
            this.title525 = res;
        });
        this._translate.get('title526').subscribe((res: string) => {
            this.title526 = res;
        });
        this._translate.get('title527').subscribe((res: string) => {
            this.title527 = res;
        });
        this._translate.get('title528').subscribe((res: string) => {
            this.title528 = res;
        });
        this._translate.get('title529').subscribe((res: string) => {
            this.title529 = res;
        });
        this._translate.get('title530').subscribe((res: string) => {
            this.title530 = res;
        });
        this._translate.get('title531').subscribe((res: string) => {
            this.title531 = res;
        });
        this._translate.get('title532').subscribe((res: string) => {
            this.title532 = res;
        });
        this._translate.get('title533').subscribe((res: string) => {
            this.title533 = res;
        });
        this._translate.get('title534').subscribe((res: string) => {
            this.title534 = res;
        });
        this._translate.get('title535').subscribe((res: string) => {
            this.title535 = res;
        });
        this._translate.get('title536').subscribe((res: string) => {
            this.title536 = res;
        });
        this._translate.get('title537').subscribe((res: string) => {
            this.title537 = res;
        });
        this._translate.get('title538').subscribe((res: string) => {
            this.title538 = res;
        });
        this._translate.get('title539').subscribe((res: string) => {
            this.title539 = res;
        });
        this._translate.get('title540').subscribe((res: string) => {
            this.title540 = res;
        });
        this._translate.get('title541').subscribe((res: string) => {
            this.title541 = res;
        });
        this._translate.get('title542').subscribe((res: string) => {
            this.title542 = res;
        });
        this._translate.get('title543').subscribe((res: string) => {
            this.title543 = res;
        });
        this._translate.get('title544').subscribe((res: string) => {
            this.title544 = res;
        });
        this._translate.get('title545').subscribe((res: string) => {
            this.title545 = res;
        });
        this._translate.get('title546').subscribe((res: string) => {
            this.title546 = res;
        });
        this._translate.get('title547').subscribe((res: string) => {
            this.title547 = res;
        });
        this._translate.get('title548').subscribe((res: string) => {
            this.title548 = res;
        });
        this._translate.get('title549').subscribe((res: string) => {
            this.title549 = res;
        });
        this._translate.get('title550').subscribe((res: string) => {
            this.title550 = res;
        });
        this._translate.get('title551').subscribe((res: string) => {
            this.title551 = res;
        });
        this._translate.get('title552').subscribe((res: string) => {
            this.title552 = res;
        });
        this._translate.get('title553').subscribe((res: string) => {
            this.title553 = res;
        });
        this._translate.get('title554').subscribe((res: string) => {
            this.title554 = res;
        });
        this._translate.get('title555').subscribe((res: string) => {
            this.title555 = res;
        });
        this._translate.get('title556').subscribe((res: string) => {
            this.title556 = res;
        });
        this._translate.get('title557').subscribe((res: string) => {
            this.title557 = res;
        });
        this._translate.get('title558').subscribe((res: string) => {
            this.title558 = res;
        });
        this._translate.get('title559').subscribe((res: string) => {
            this.title559 = res;
        });
        this._translate.get('title560').subscribe((res: string) => {
            this.title560 = res;
        });
        this._translate.get('title561').subscribe((res: string) => {
            this.title561 = res;
        });
        this._translate.get('title562').subscribe((res: string) => {
            this.title562 = res;
        });
        this._translate.get('tittle563').subscribe((res: string) => {
            this.tittle563 = res;
        });
        this._translate.get('tittle564').subscribe((res: string) => {
            this.tittle564 = res;
        });
        this._translate.get('tittle565').subscribe((res: string) => {
            this.tittle565 = res;
        });
        this._translate.get('tittle566').subscribe((res: string) => {
            this.tittle566 = res;
        });
        this._translate.get('tittle567').subscribe((res: string) => {
            this.tittle567 = res;
        });
        this._translate.get('tittle568').subscribe((res: string) => {
            this.tittle568 = res;
        });
        this._translate.get('tittle569').subscribe((res: string) => {
            this.tittle569 = res;
        });
        this._translate.get('tittle570').subscribe((res: string) => {
            this.tittle570 = res;
        });
        this._translate.get('title').subscribe((res: string) => {
            this.title = res;
        });
        this._translate.get('title').subscribe((res: string) => {
            this.title = res;
        });
        this._translate.get('title').subscribe((res: string) => {
            this.title = res;
        });
        this._translate.get('title').subscribe((res: string) => {
            this.title = res;
        });
        this._translate.get('title').subscribe((res: string) => {
            this.title = res;
        });
        this._translate.get('description').subscribe((res: string) => {
            this.description = res;
        });
        this._translate.get('TITLE_2', { value: 'John' }).subscribe((res: string) => {
            this.title_2 = res;
        });
        this._translate.get('data.name', { name_value: 'Marissa Mayer' }).subscribe((res: string) => {
            this.name = res;
        });
        this._translate.get('title571').subscribe((res: string) => {
            this.title571 = res;
        });
        this._translate.get('title572').subscribe((res: string) => {
            this.title572 = res;
        });
        this._translate.get('title573').subscribe((res: string) => {
            this.title573 = res;
        });
        this._translate.get('title574').subscribe((res: string) => {
            this.title574 = res;
        });
        this._translate.get('title575').subscribe((res: string) => {
            this.title575 = res;
        });
        this._translate.get('title576').subscribe((res: string) => {
            this.title576 = res;
        });
        this._translate.get('title577').subscribe((res: string) => {
            this.title577 = res;
        });
        this._translate.get('title578').subscribe((res: string) => {
            this.title578 = res;
        });
        this._translate.get('title578').subscribe((res: string) => {
            this.title578 = res;
        });
        this._translate.get('title579').subscribe((res: string) => {
            this.title579 = res;
        });
        this._translate.get('title580').subscribe((res: string) => {
            this.title580 = res;
        });
        this._translate.get('title581').subscribe((res: string) => {
            this.title581 = res;
        });
        this._translate.get('title582').subscribe((res: string) => {
            this.title582 = res;
        });
        this._translate.get('title583').subscribe((res: string) => {
            this.title583 = res;
        });
        this._translate.get('title584').subscribe((res: string) => {
            this.title584 = res;
        });
        this._translate.get('title585').subscribe((res: string) => {
            this.title585 = res;
        });
        this._translate.get('title586').subscribe((res: string) => {
            this.title586 = res;
        });
        this._translate.get('title587').subscribe((res: string) => {
            this.title587 = res;
        });
        this._translate.get('title588').subscribe((res: string) => {
            this.title588 = res;
        });
        this._translate.get('title589').subscribe((res: string) => {
            this.title589 = res;
        });
        this._translate.get('title590').subscribe((res: string) => {
            this.title590 = res;
        });
        this._translate.get('title591').subscribe((res: string) => {
            this.title591 = res;
        });
        this._translate.get('title592').subscribe((res: string) => {
            this.title592 = res;
        });
        this._translate.get('title593').subscribe((res: string) => {
            this.title593 = res;
        });
        this._translate.get('title594').subscribe((res: string) => {
            this.title594 = res;
        });
        this._translate.get('title595').subscribe((res: string) => {
            this.title595 = res;
        });
        this._translate.get('title596').subscribe((res: string) => {
            this.title596 = res;
        });
        this._translate.get('title597').subscribe((res: string) => {
            this.title597 = res;
        });
        this._translate.get('title598').subscribe((res: string) => {
            this.title598 = res;
        });
        this._translate.get('title599').subscribe((res: string) => {
            this.title599 = res;
        });
        this._translate.get('title600').subscribe((res: string) => {
            this.title600 = res;
        });
        this._translate.get('title601').subscribe((res: string) => {
            this.title601 = res;
        });
        this._translate.get('title602').subscribe((res: string) => {
            this.title602 = res;
        });
        this._translate.get('title603').subscribe((res: string) => {
            this.title603 = res;
        });
        this._translate.get('title604').subscribe((res: string) => {
            this.title604 = res;
        });
        this._translate.get('title605').subscribe((res: string) => {
            this.title605 = res;
        });
        this._translate.get('title606').subscribe((res: string) => {
            this.title606 = res;
        });
        this._translate.get('title607').subscribe((res: string) => {
            this.title607 = res;
        });
        this._translate.get('title608').subscribe((res: string) => {
            this.title608 = res;
        });
        this._translate.get('title609').subscribe((res: string) => {
            this.title609 = res;
        });
        this._translate.get('title610').subscribe((res: string) => {
            this.title610 = res;
        });
        this._translate.get('title611').subscribe((res: string) => {
            this.title611 = res;
        });
        this._translate.get('title612').subscribe((res: string) => {
            this.title612 = res;
        });
        this._translate.get('title613').subscribe((res: string) => {
            this.title613 = res;
        });
        this._translate.get('title614').subscribe((res: string) => {
            this.title614 = res;
        });
        this._translate.get('title615').subscribe((res: string) => {
            this.title615 = res;
        });
        this._translate.get('title616').subscribe((res: string) => {
            this.title616 = res;
        });
        this._translate.get('title617').subscribe((res: string) => {
            this.title617 = res;
        });
        this._translate.get('title618').subscribe((res: string) => {
            this.title618 = res;
        });
        this._translate.get('title619').subscribe((res: string) => {
            this.title619 = res;
        });
        this._translate.get('title620').subscribe((res: string) => {
            this.title620 = res;
        });
        this._translate.get('title621').subscribe((res: string) => {
            this.title621 = res;
        });
        this._translate.get('title622').subscribe((res: string) => {
            this.title622 = res;
        });
        this._translate.get('title623').subscribe((res: string) => {
            this.title623 = res;
        });
        this._translate.get('title624').subscribe((res: string) => {
            this.title624 = res;
        });
        this._translate.get('title625').subscribe((res: string) => {
            this.title625 = res;
        });
        this._translate.get('title626').subscribe((res: string) => {
            this.title626 = res;
        });
        this._translate.get('title627').subscribe((res: string) => {
            this.title627 = res;
        });
        this._translate.get('title628').subscribe((res: string) => {
            this.title628 = res;
        });
        this._translate.get('title629').subscribe((res: string) => {
            this.title629 = res;
        });
        this._translate.get('title630').subscribe((res: string) => {
            this.title630 = res;
        });
        this._translate.get('title631').subscribe((res: string) => {
            this.title631 = res;
        });
        this._translate.get('title632').subscribe((res: string) => {
            this.title632 = res;
        });
        this._translate.get('title633').subscribe((res: string) => {
            this.title633 = res;
        });
        this._translate.get('title634').subscribe((res: string) => {
            this.title634 = res;
        });
        this._translate.get('title635').subscribe((res: string) => {
            this.title635 = res;
        });
        this._translate.get('title636').subscribe((res: string) => {
            this.title636 = res;
        });
        this._translate.get('title637').subscribe((res: string) => {
            this.title637 = res;
        });
        this._translate.get('title638').subscribe((res: string) => {
            this.title638 = res;
        });
        this._translate.get('title639').subscribe((res: string) => {
            this.title639 = res;
        });
        this._translate.get('title640').subscribe((res: string) => {
            this.title640 = res;
        });
        this._translate.get('title641').subscribe((res: string) => {
            this.title641 = res;
        });
        this._translate.get('title642').subscribe((res: string) => {
            this.title642 = res;
        });
        this._translate.get('title643').subscribe((res: string) => {
            this.title643 = res;
        });
        this._translate.get('title644').subscribe((res: string) => {
            this.title644 = res;
        });
        this._translate.get('title645').subscribe((res: string) => {
            this.title645 = res;
        });
        this._translate.get('title646').subscribe((res: string) => {
            this.title646 = res;
        });
        this._translate.get('title647').subscribe((res: string) => {
            this.title647 = res;
        });
        this._translate.get('title648').subscribe((res: string) => {
            this.title648 = res;
        });
        this._translate.get('title649').subscribe((res: string) => {
            this.title649 = res;
        });
        this._translate.get('title650').subscribe((res: string) => {
            this.title650 = res;
        });
        this._translate.get('title651').subscribe((res: string) => {
            this.title651 = res;
        });
        this._translate.get('title652').subscribe((res: string) => {
            this.title652 = res;
        });
        this._translate.get('title653').subscribe((res: string) => {
            this.title653 = res;
        });
        this._translate.get('title654').subscribe((res: string) => {
            this.title654 = res;
        });
        this._translate.get('title655').subscribe((res: string) => {
            this.title655 = res;
        });
        this._translate.get('title656').subscribe((res: string) => {
            this.title656 = res;
        });
        this._translate.get('title657').subscribe((res: string) => {
            this.title657 = res;
        });
        this._translate.get('title658').subscribe((res: string) => {
            this.title658 = res;
        });
        this._translate.get('title659').subscribe((res: string) => {
            this.title659 = res;
        });
        this._translate.get('title660').subscribe((res: string) => {
            this.title660 = res;
        });
        this._translate.get('title661').subscribe((res: string) => {
            this.title661 = res;
        });
        this._translate.get('title662').subscribe((res: string) => {
            this.title662 = res;
        });
        this._translate.get('title663').subscribe((res: string) => {
            this.title663 = res;
        });
        this._translate.get('title664').subscribe((res: string) => {
            this.title664 = res;
        });
        this._translate.get('title665').subscribe((res: string) => {
            this.title665 = res;
        });
        this._translate.get('title666').subscribe((res: string) => {
            this.title666 = res;
        });
        this._translate.get('title667').subscribe((res: string) => {
            this.title667 = res;
        });
        this._translate.get('title668').subscribe((res: string) => {
            this.title668 = res;
        });
        this._translate.get('title669').subscribe((res: string) => {
            this.title669 = res;
        });
        this._translate.get('title670').subscribe((res: string) => {
            this.title670 = res;
        });
        this._translate.get('title671').subscribe((res: string) => {
            this.title671 = res;
        });
        this._translate.get('title672').subscribe((res: string) => {
            this.title672 = res;
        });
        this._translate.get('title673').subscribe((res: string) => {
            this.title673 = res;
        });
        this._translate.get('title674').subscribe((res: string) => {
            this.title674 = res;
        });
        this._translate.get('title675').subscribe((res: string) => {
            this.title675 = res;
        });
        this._translate.get('title676').subscribe((res: string) => {
            this.title676 = res;
        });
        this._translate.get('title677').subscribe((res: string) => {
            this.title677 = res;
        });
        this._translate.get('title678').subscribe((res: string) => {
            this.title678 = res;
        });
        this._translate.get('title679').subscribe((res: string) => {
            this.title679 = res;
        });
        this._translate.get('title680').subscribe((res: string) => {
            this.title680 = res;
        });
        this._translate.get('title681').subscribe((res: string) => {
            this.title681 = res;
        });
        this._translate.get('title682').subscribe((res: string) => {
            this.title682 = res;
        });
        this._translate.get('title683').subscribe((res: string) => {
            this.title683 = res;
        });
        this._translate.get('title684').subscribe((res: string) => {
            this.title684 = res;
        });
        this._translate.get('title685').subscribe((res: string) => {
            this.title685 = res;
        });
        this._translate.get('title686').subscribe((res: string) => {
            this.title686 = res;
        });
        this._translate.get('title687').subscribe((res: string) => {
            this.title687 = res;
        });
        this._translate.get('title688').subscribe((res: string) => {
            this.title688 = res;
        });
        this._translate.get('title689').subscribe((res: string) => {
            this.title689 = res;
        });
        this._translate.get('title690').subscribe((res: string) => {
            this.title690 = res;
        });
        this._translate.get('title691').subscribe((res: string) => {
            this.title691 = res;
        });
        this._translate.get('title692').subscribe((res: string) => {
            this.title692 = res;
        });
        this._translate.get('title693').subscribe((res: string) => {
            this.title693 = res;
        });
        this._translate.get('title694').subscribe((res: string) => {
            this.title694 = res;
        });
        this._translate.get('title695').subscribe((res: string) => {
            this.title695 = res;
        });
        this._translate.get('title696').subscribe((res: string) => {
            this.title696 = res;
        });
        this._translate.get('title697').subscribe((res: string) => {
            this.title697 = res;
        });
        this._translate.get('title698').subscribe((res: string) => {
            this.title698 = res;
        });
        this._translate.get('title699').subscribe((res: string) => {
            this.title699 = res;
        });
        this._translate.get('title700').subscribe((res: string) => {
            this.title700 = res;
        });
        this._translate.get('title701').subscribe((res: string) => {
            this.title701 = res;
        });
        this._translate.get('title702').subscribe((res: string) => {
            this.title702 = res;
        });
        this._translate.get('title703').subscribe((res: string) => {
            this.title703 = res;
        });
        this._translate.get('title704').subscribe((res: string) => {
          this.title704 = res;
      });
        this._translate.get('title705').subscribe((res: string) => {
          this.title705 = res;
      });
        this._translate.get('title706').subscribe((res: string) => {
          this.title706 = res;
      });
        this._translate.get('title707').subscribe((res: string) => {
          this.title707 = res;
      });
        this._translate.get('title708').subscribe((res: string) => {
          this.title708 = res;
      });
        this._translate.get('title709').subscribe((res: string) => {
          this.title709 = res;
      });
        this._translate.get('title710').subscribe((res: string) => {
          this.title710 = res;
      });
        this._translate.get('title711').subscribe((res: string) => {
          this.title711 = res;
      });
        this._translate.get('title712').subscribe((res: string) => {
          this.title712 = res;
      });
        this._translate.get('title713').subscribe((res: string) => {
          this.title713 = res;
      });
        this._translate.get('title714').subscribe((res: string) => {
          this.title714 = res;
      });
      this._translate.get('title715').subscribe((res: string) => {
        this.title715 = res;
    });
    this._translate.get('title716').subscribe((res: string) => {
        this.title716 = res;
    });
    this._translate.get('title717').subscribe((res: string) => {
        this.title717 = res;
    });
    this._translate.get('title718').subscribe((res: string) => {
        this.title718 = res;
    });
    this._translate.get('title719').subscribe((res: string) => {
        this.title719 = res; 
    });
    this._translate.get('title720').subscribe((res: string) => {
        this.title720 = res;
    });
    this._translate.get('title721').subscribe((res: string) => {
        this.title721 = res;
    });
    this._translate.get('title722').subscribe((res: string) => { 
        this.title722 = res; 
    }); 
    this._translate.get('title723').subscribe((res: string) => {
        this.title723 = res;
    });
    this._translate.get('title724').subscribe((res: string) => { 
        this.title724 = res; 
    }); 
    this._translate.get('title725').subscribe((res: string) => { 
        this.title725 = res; 
    }); 
    this._translate.get('title726').subscribe((res: string) => { 
        this.title726 = res; 
    }); 
    this._translate.get('title727').subscribe((res: string) => { 
        this.title727 = res; 
    });  
    this._translate.get('title728').subscribe((res: string) => {
        this.title728 = res;
    }); 
    this._translate.get('title729').subscribe((res: string) => {
        this.title729 = res; 
    }); 
    this._translate.get('title730').subscribe((res: string) => {
        this.title730 = res; 
    }); 
    this._translate.get('title731').subscribe((res: string) => {
        this.title731 = res; 
    });
    this._translate.get('title732').subscribe((res: string) => {
        this.title732 = res;
    }); 
    this._translate.get('title733').subscribe((res: string) => {
        this.title733 = res;
    });
    this._translate.get('title744').subscribe((res: string) => {
        this.title744 = res;
    });
    this._translate.get('title745').subscribe((res: string) => {
        this.title745 = res;
    });
    this._translate.get('title746').subscribe((res: string) => {
        this.title746 = res;
    });
    }

    changeDateLan(changeDate) {
        this.Date = changeDate;
        this.selectedDate = changeDate;

        if (this.selectedLanguage == 'ea') {
            var date = new Date();
            var months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
                "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
            ];
            var days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
            this.Date = this.Date.getDate() + ',' + months[this.Date.getMonth()] + ', ' + this.Date.getFullYear();
            this.selectedDate = this.selectedDate.getDate() + ' ' + months[this.selectedDate.getMonth()] + ', ' + this.selectedDate.getFullYear();

            console.log("this.Date", this.Date);
        } else if (this.selectedLanguage == 'en') {
            // this.Date = formatDate(this.Date, "dd-MMM-yy", "en-Us");
            this.Date = formatDate(this.Date, "dd-MMM-yy", "en-Us");
        }
    }

    _translateLanguage(): void {

        this._translate.use(this.language);
        this.initialiseTranslation();
    }

    checkTranslate() {

        this.language = localStorage.getItem("selectedLanguage") ? localStorage.getItem("selectedLanguage") : "en";
        this.selectedLanguage = localStorage.getItem("selectedLanguage") ? localStorage.getItem("selectedLanguage") : "en";

        if (this.selectedLanguage == 'ea') {
            var root = document.documentElement;
            root.setAttribute('style', '--direction:rtl');
        } else if (this.selectedLanguage == 'en') {
            var root = document.documentElement;
            root.setAttribute('style', '--direction:ltr');
        }
        this._translateLanguage();
    }

}
